module.exports = "<div class=\"s-button-icon\" [hidden]=\"Skeleton.Hidden\">\r\n  <button [disabled]=\"Skeleton.Disable\" class=\"btn\" (click)=\"OnClick()\">\r\n    <i [hidden]=\"!Skeleton.IconCss\" [ngClass]=\"Skeleton.IconCss || ''\"></i>\r\n    <span> {{ Skeleton.Label }} </span>\r\n  </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/s-button-icon/s-button-icon.component.html
// module id = ./src/app/shared/components/s-button-icon/s-button-icon.component.html
// module chunks = main